import { Variant } from '../../types/product';
import updateAddToCartBtn from './updateAddToCartBtn';

const preselectVariantFromUrl = (variantsData: Variant[], variantsContainer: HTMLDivElement, atcBtnEl: HTMLButtonElement): void => {
  const url = new URL(window.location.href);
  const variantId: number | null = Number(url.searchParams.get('variant'));
  if (variantId === null) return;

  const selectedVariant = variantsData.find((variant): boolean => variant.id === variantId);
  if (!selectedVariant) return;

  selectedVariant.options.forEach((option): void => {
    const optionInput = variantsContainer?.querySelector<HTMLInputElement>(`[data-product-variants-input][value="${option}"]`);
    if (optionInput) optionInput.checked = true;
  });
  updateAddToCartBtn(atcBtnEl);
};

export default preselectVariantFromUrl;
